import { useMemo } from 'react';

import { Bean, FieldControllerProps, PercentagePatternType, ValidationRules } from '@dreryk/react-common';
import { PercentageInput, StyledMaxWidth } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../../translations';

import { MedicalServiceProportionalValue } from './proportionalValue.types';

type MedicalServiceProportionalValueFieldProps = FieldControllerProps<
   'proportionalValue',
   MedicalServiceProportionalValue | null | undefined
> & {
   readonly disabled?: boolean;
};

export const MedicalServiceProportionalValueField = (props: MedicalServiceProportionalValueFieldProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: props.required,
      };
   }, [props.required]);

   return (
      <StyledMaxWidth maxWidth={133}>
         <PercentageInput
            testId={props.name}
            label={medicalServiceTranslationKeys.shared.proportionalValue.field.label}
            controller={props.register(props.name, validationRules)}
            defaultValue={props.defaultValue}
            pattern={PercentagePatternType.POSITIVE}
            min={1}
            max={100}
            nowrap
            disabled={props.disabled}
         />
      </StyledMaxWidth>
   );
};
